module.exports = __webpack_public_path__ + "static/img/4.0562fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/4.png
// module id = CUS0
// module chunks = 0